import React from "react"
import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useAuth } from "../../hooks"
import { jwtDecode } from 'jwt-decode';

const RoleAccess = ({ roles = [] }: {
    roles: string[]
}) => {
    const { auth } = useAuth()  
    
    return !auth?.role?.length || roles.includes(auth?.role)
      ? <Outlet />
      : <Navigate to="/unauthorized" replace />;
  };

export default RoleAccess;